export function prettyPrint(data: unknown) {
  const JSON_SPACING = 2;
  return JSON.stringify(data, null, JSON_SPACING);
}
